import * as yup from 'yup';

const rulesNumber: RegExp = /^\d+$/;
const rulesIp: RegExp = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/;

export const ModalWorkpaceSchema = yup.object({
  workpaceName: yup
    .string()
    .required('Поле обязательно для заполнения'),
  boardNumber: yup
    .string()
    .max(3, 'Превышен лимит символов')
    .matches(rulesNumber, { message: 'Введите номер корректно', excludeEmptyString: true }),
  officeNumber: yup
    .string()
    .max(3, 'Превышен лимит символов')
    .when('boardNumber', {
      is: (boardNumber: string) => !boardNumber || boardNumber.length === 0,
      then: (schema) => schema.required('Введите номер кабинета или окна'),
      otherwise: (schema) => schema
    })
    .matches(rulesNumber, { message: 'Введите номер корректно', excludeEmptyString: true }),
  searchInputText: yup.string(),
  type: yup.string().required('Выберите уровень доступа'),
  digitalDisplayIp: yup
    .string()
    .when('type', {
      is: (val: string) => val === 'Оператор на въезд',
      then: (schema) => schema.required(' '),
      otherwise: (schema) => schema
    })
    .matches(rulesIp, { message: 'Введите адрес корректно', excludeEmptyString: true }),
  queueName: yup.string().max(128, 'Не более 128 символов').nullable(),
  users: yup.array()
});
